/** Survives React Strict Mode remount when createPayment URL params are cleared. */
let pendingPaymentCreate: { projectId: string | null } | null = null;

export function capturePaymentCreateDeepLink(projectId: string | null): void {
  pendingPaymentCreate = { projectId };
}

/** Peek without consuming — Strict Mode remount needs a second read. */
export function peekPaymentCreateDeepLink(): { projectId: string | null } | null {
  return pendingPaymentCreate;
}

export function clearPaymentCreateDeepLink(): void {
  pendingPaymentCreate = null;
}
